import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomePage/index.vue'),
    meta: {
      title: '首页',
      name: '首页',
      keepAlive: true,
    },
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/AboutPage/index.vue'),
    meta: {
      title: '关于博源',
      name: '关于博源',
    },
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/NewsPage/index.vue'),
    meta: {
      title: '新闻中心',
      name: '新闻中心',
    },
  },
  {
    path: '/smart-finance',
    name: 'SmartFinance',
    component: () => import('@/views/SmartFinancePage/index.vue'),
    meta: {
      title: '智慧金融',
      name: '智慧金融',
    },
  },
  {
    path: '/financial-self-service',
    name: 'FinancialSelfService',
    component: () => import('@/views/FinancialSelfServicePage/index.vue'),
    meta: {
      title: '金融自助设备',
      name: '金融自助设备',
    },
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/ProductsPage/index.vue'),
    meta: {
      title: '产品中心',
      name: '产品中心',
    },
  },
  {
    path: '/security-protection',
    name: 'SecurityProtection',
    component: () => import('@/views/SecurityProtectionPage/index.vue'),
    meta: {
      title: '自助银行防护',
      name: '自助银行防护',
    },
  },
  {
    path: '/brand-vi',
    name: 'BrandVi',
    component: () => import('@/views/BrandViPage/index.vue'),
    meta: {
      title: '网点形象',
      name: '网点形象',
    },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/ContactPage/index.vue'),
    meta: {
      title: '联系我们',
      name: '联系我们',
    },
  },
  {
    path: '/product-detail/:id',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetailPage/index.vue'),
    meta: {
      title: '设备详情',
      name: '设备详情',
    },
  },
];

const router = new VueRouter({
  mode: 'hash',
  routes,
});
// 路由跳转前强制滚动到顶部（取消所有滚动动画）
router.beforeEach((to, from, next) => {
  // 取消所有滚动动画
  window.scrollTo({ top: 0, behavior: 'auto' });
  next();
});
 
// 路由跳转后再次强制滚动到顶部
router.afterEach((to, from) => {
  // 立即滚动到顶部
  window.scrollTo(0, 0);
  // 使用requestAnimationFrame确保DOM更新后再滚动一次
  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
  });
});

export default router;
